import * as types from './types';

const addProductToCart = () => {
    return {
        type: types.ADD_PRODUCT_TO_CART
    };
};

const removeProductFromCart = () => {
    return {
        type: types.REMOVE_PRODUCT_FROM_CART
    };
};

const triggerCartLoading = cartLoading => {
    return {
        type: types.TRIGGER_CART_LOADING,
        cartLoading: cartLoading
    };
};

const triggerMinicartAnimation = minicartAnimation => {
    return {
        type: types.TRIGGER_MINICART_ANIMATION,
        minicartAnimation: minicartAnimation
    };
};

export {
    addProductToCart,
    removeProductFromCart,
    triggerCartLoading,
    triggerMinicartAnimation
};



// WEBPACK FOOTER //
// ./src/components/ProductItem/actions/actions.js